module.exports = __webpack_public_path__ + "img/im.8e8f624b.svg";